import { getRoute } from '@/authorized'
export default {
  computed: {
    // 注入匹配路由的权限
    role() {
      let path = this.$route.path.toLowerCase()
      return getRoute(path, this.$store.state.menus) || {}
    }
  }
}
